<div class="d-flex align-items-center p-2 border-bottom">

  <div *ngIf="selectable" class="me-2">
    <input type="checkbox" class="form-check-input" [(ngModel)]="selected">
  </div>

  <div class="me-2">
    <button type="button" class="btn p-0" (click)="sendToCase()">
      <fa-icon [icon]="faShareSquare" size="lg"></fa-icon>
    </button>
  </div>

  <div class="d-flex justify-content-center align-items-center rounded-circle border me-3"
       style="width: 40px; height: 40px; min-width: 40px; background-color: white;">
    <fa-icon [icon]="caseFilesService.getFileTypeIcon(details.format)" size="lg"></fa-icon>
  </div>

  <div class="flex-grow-1">
    <div class="fw-semibold small">{{details.fileName}}</div>
    <div class="text-muted small">{{details.createdDateTime | date:'dd/MM/yyyy HH:mm:ss'}}</div>
  </div>

</div>